var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('side-bar'),_c('div',{staticClass:"flex-1"},[_c('transition',{attrs:{"name":"scale-transition"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }